import React, { useState, useEffect, useRef } from 'react';
import { CgAdd, CgCloseO } from "react-icons/cg";
import { LuSearch } from "react-icons/lu";
import Formulario from '../../components/Fomulario/formvenda.jsx';
import FormularioCompra from '../../components/Fomulario/formcompra.jsx';
import Tabela from '../../components/Tabela/tabvenda.jsx';
import { toast, ToastContainer } from "react-toastify"; // Corrigido import do ToastContainer
import "react-toastify/dist/ReactToastify.css";
import Spinner from '../../components/Spinner/carregando.jsx';
import api from '../../services/api';
import useConfirmDialog from "../../components/ConfirmModal/useConfirmDialog.jsx";
const cx = (...names) => names.filter(Boolean).map((n) => styles[n] || n).join(' ');
import ui from '../../styles/ui.module.css';
import styles from './vendas.module.css';


// Helper para obter primeiro e último dia do mês atual (YYYY-MM-DD)
const getMonthRange = () => {
  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth(), 1);
  const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  const toISO = (d) => d.toISOString().slice(0, 10);
  return { start: toISO(start), end: toISO(end) };
};

function Vendas({}) {
  const sucessoNotificado = useRef(false);
  const erroNotificado = useRef(false);
  const { confirm, ConfirmModal } = useConfirmDialog({
    confirmClassName: `${ui.butdesktop} ${ui.btnPrimary}`,
    cancelClassName: ui.butdesktop,
  });
  const [filtroVendas, setFiltroVendas] = useState({
    dataInicio: "",
    dataFim: "",
    nomeFiltro: "",
    cpfFiltro: "",
  });
  const nomeInputRef = useRef(null);
  const [sugestoes, setSugestoes] = useState([]);
  const [dataListTabela, setDataListTabela] = useState({});
  const [filtrosDoVendas, setFiltrosDoVendas] = useState([]);
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [tabelaOperacao, setTabelaOperacao] = useState('VENDA'); // Filtro da tabela: VENDA | COMPRA
  const [operacao, setOperacao] = useState('VENDA');
  // edição de compra reutiliza o próprio formulário de compras (formData + operacao)
  const [editando, setEditando] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [erroAoSalvarVenda, setErroAoSalvarVenda] = useState(false);
  const [dataList, setDataList] = useState([]) /* => {
    // Carrega dataList do localStorage ao inicializar
    if (typeof window !== "undefined") {
      const saved = localStorage.getItem("vendas");
      return saved ? JSON.parse(saved) : [];
    }
    return [];
  });*/

  // Inicializa datas padrão no primeiro render
  useEffect(() => {
    if (!filtroVendas.dataInicio || !filtroVendas.dataFim) {
      const { start, end } = getMonthRange();
      setFiltroVendas((prev) => ({ ...prev, dataInicio: start, dataFim: end }));
      // Aplica filtros padrão também
      setFiltrosDoVendas((prev) => ({ ...prev, dataInicio: start, dataFim: end, nomeFiltro: prev?.nomeFiltro || '' }));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // removido: dataListBank (não utilizado)
  const [formData, setFormData] = useState({
    data: "",
    compraBobDia: "",
    nomeBRL: "",
    nomeBOB: "",
    valorBRL: "",
    valorBOB: "",
    usdtQuantidade: "",
  });

  //console.log("ln 58, filtrosDoVendas:", filtrosDoVendas) 
  //console.log("ln 60, filtroVendas:", filtroVendas)

  // Opcional: controle de quantas tentativas de retry já foram feitas
  const retriesRef = useRef(0);
  const MAX_RETRIES = 1; // por exemplo, só tentar recarregar uma vez em caso de ERR_NETWORK


  const carregarLista = async (modo = tabelaOperacao) => {
    setIsLoading(true);
    try {
      // Define o período a usar nas consultas
      const { start, end } = getMonthRange();
      const dataInicio = filtrosDoVendas?.dataInicio || filtroVendas?.dataInicio || start;
      const dataFim = filtrosDoVendas?.dataFim || filtroVendas?.dataFim || end;
      if (modo === 'COMPRA') {
        const resp = await api.get('/compras', { params: { dataInicio, dataFim } });
        const rows = Array.isArray(resp.data) ? resp.data : [];
        // Mapeia campos que a Tabela espera
        const mapped = rows.map((r) => ({
          ...r,
          TAXADIA: r.COMPRABOBDIA,
          LUCROBOB: r.LUCROBOB || 0,
          LUCROBRL: r.LUCROBRL || 0,
          PERCBRL: r.PERCBRL || 0,
        }));
        setDataList(mapped);
      } else {
        const respostaVendas = await api.get('/vendas', { params: { dataInicio, dataFim } });
        setDataList(respostaVendas.data);
        if (!sucessoNotificado.current) {
          toast.success("Vendas carregadas com sucesso!");
          sucessoNotificado.current = true;
        }
      }
    } catch (erro) {
      if (!erroNotificado.current) {
        toast.error("Erro ao carregar lista");
        erroNotificado.current = true;
      }
      if (erro.code === 'ERR_NETWORK' && retriesRef.current < MAX_RETRIES) {
        retriesRef.current += 1;
        setTimeout(() => carregarLista(modo), 3000);
        return;
      }
      setErroAoSalvarVenda(true);
    } finally {
      setIsLoading(false);
    }
  };

  // Unificado: a carga inicial ocorre via efeito que observa tabelaOperacao e filtrosDoVendas
  useEffect(() => { carregarLista(tabelaOperacao); }, [tabelaOperacao, filtrosDoVendas?.dataInicio, filtrosDoVendas?.dataFim]);

  useEffect(() => {
    // Recarrega vendas somente quando flag estiver verdadeira
    if (!erroAoSalvarVenda) return;
    const reCarregarVendas = async () => {
      try {
        setIsLoading(true);
        await carregarLista(tabelaOperacao);
      } finally {
        setErroAoSalvarVenda(false);
        setIsLoading(false);
      }
    };
    reCarregarVendas();
  }, [erroAoSalvarVenda]);


   // Sincroniza dataList com localStorage sempre que mudar
  /*useEffect(() => {
    if (typeof window !== "undefined" && dataList.length > 0) {
      const vendOrdLocStoeage = dataList
        .sort((a, b) => new Date(b.DATA) - new Date(a.DATA))
        .slice(0, 100);   
      localStorage.setItem("vendas", JSON.stringify(vendOrdLocStoeage));
    }
  }, [dataList]);

  // Sincroniza sugestoes com localStorage sempre que mudar
  useEffect(() => {
    if (typeof window !== "undefined" && sugestoes.length > 0) {
      const clienteLocStoeage = sugestoes  
      localStorage.setItem("clientes", JSON.stringify(clienteLocStoeage));
    }
  }, [sugestoes]);*/

  const enviarConf = async (aSalvar) => {
    const itensASalvar = Object.values(aSalvar);
    if (!itensASalvar.length) return;
    setIsLoading(true);
    try {
      const resultados = await Promise.all(
        itensASalvar.map((item) =>
          api
            .put(`/vendas/conferencia/${item.ID}`, {
              CONFVALORBRL: item.CONFVALORBRL,
              CONFVALORBOB: item.CONFVALORBOB,
            })
            .then((res) => ({ ok: true, id: item.ID, res }))
            .catch((err) => ({ ok: false, id: item.ID, err }))
        )
      );

      const sucesso = resultados.filter((r) => r.ok).length;
      const falhas = resultados.length - sucesso;

      // O mapa detalhado de resultados não é necessário na UI; removido

      if (sucesso) toast.success(`Conferência salva para ${sucesso} item(ns).`);
      if (falhas) toast.error(`${falhas} falha(s) ao salvar conferência.`);

      // Recarrega a lista explicitamente após salvar, respeitando os filtros atuais
      await carregarLista('VENDA');
      // Limpa marcações pendentes de conferência
      setDataListTabela({});
    } catch (error) {
      console.error("Erro ao salvar conferência:", error);
      const status = error?.response?.status;
      if (status === 500) {
        toast.error(
          "Falha ao conectar com o servidor, aguarde alguns segundos e tente novamente."
        );
      } else {
        toast.error("Erro ao salvar conferência nas vendas.");
      }
    } finally {
      setIsLoading(false);
    }
  };
  
  // Função para lidar com novos envios do formulário
  const handleNewSubmission = async (newEntry, tipo = 'VENDA') => {
    
    //console.log("Nova venda antes de enviar:", newEntry);

    if (!newEntry.data || !newEntry.compraBobDia || !newEntry.nomeBRL || !newEntry.valorBRL || !newEntry.valorBOB ) {
      //console.log("Precncha todos os campos");
    } else {
      
  
    try {
      //console.log("ln 219 newEntry:", newEntry);
      const itemIdToEdit = formData; 
      //console.log("ln 221, função EDITAR: ", itemIdToEdit);

      newEntry.id_cliente = newEntry.idCliente;

      //console.log("ln 237, newEntry:", newEntry);
      //console.log("ln 237, formData:", formData);

      let resposta;

      if (tipo === 'COMPRA') {
        // Envia para a rota de compras
        const resp = newEntry.id
          ? await api.put(`/compras/${newEntry.id}`, newEntry)
          : await api.post('/compras', newEntry);
        if (resp.status === 201) {
          toast.success('Compra salva com sucesso!');
        } else if (resp.status === 200) {
          toast.success('Compra atualizada com sucesso!');
        } else {
          toast.warn('Não foi possível salvar a compra.');
        }
        // Recarrega listas (pode-se criar uma listagem específica para compras depois)
        await carregarLista(tabelaOperacao);
        return;
      }

      if (editando) { // Verifica se está editando
        newEntry.id = formData.id;
        //console.log("ln 227 função POST: ", newEntry);
        setMostrarFormulario(false);
        setIsLoading(true)
        setEditando(false);
        resposta = await api.put(`/vendas/${newEntry.id}`, newEntry); // Usa api em vez de axios direto
        

        //console.log("resposta UPDATE", resposta);

         if (resposta.status === 200) {
          toast.success("Venda atualizada com sucesso!");
        } else {
          toast.error("Falha ao atualizar venda.");
        }
        
      } else {
        //console.log("Criando nova venda:", newEntry);
        //console.log("ln 227 função PUT: ", newEntry);
        setIsLoading(true)
        resposta = await api.post("/vendas", newEntry); // Usa api em vez de axios direto

        //console.log("resposta NOVO", resposta)
        if (resposta.status === 200 || resposta.status === 201) {
          toast.success("Venda salva com sucesso!");
        } else {
          toast.error("Falha ao criar venda.");
        }
      }
    
      await carregarLista(tabelaOperacao);
      

      const respostaData = resposta?.data;
      const dadosResposta = Array.isArray(respostaData)
        ? respostaData
        : respostaData
          ? [respostaData]
          : [];

      let vendaMaisRecente = dadosResposta.length ? dadosResposta[0] : null;
      if (dadosResposta.length > 1) {
        vendaMaisRecente = dadosResposta.reduce((maisRecente, vendaAtual) => {
          if (!maisRecente) return vendaAtual;
          if (!vendaAtual) return maisRecente;
          const dataAtual = new Date(vendaAtual.DATA || vendaAtual.data || 0);
          const dataMaisRecente = new Date(maisRecente.DATA || maisRecente.data || 0);
          return dataAtual > dataMaisRecente ? vendaAtual : maisRecente;
        }, vendaMaisRecente);
      }

      const vendaParaForm = vendaMaisRecente || newEntry;

      setFormData({
        data: vendaParaForm?.DATA || vendaParaForm?.data || "",
        compraBobDia: vendaParaForm?.COMPRABOBDIA || vendaParaForm?.compraBobDia || "",
        nomeBRL: "",
        nomeBOB: "",
        valorBRL: "",
        valorBOB: "",
        usdtQuantidade: "",
      });
      //setMostrarFormulario(false);
      
      setEditando(false); // Reseta o estado de edição
    } catch (error) {
      console.error("Erro ao SALVAR venda:", error);
        if (error?.response?.status === 500) {
          toast.error(`Falha ao conectar com o servidor, aguarde 10 segundos enquanto reinicio a conexção!: `)
          
        } else {
        toast.error(`Erro ao SALVAR venda`)
        }
        setErroAoSalvarVenda(true);
    } finally {
      setIsLoading(false)
    }
    }
  };

  const handleEdit = (row) => {
    if (tabelaOperacao === 'COMPRA') {
      // abre o mesmo formulário de COMPRA com dados preenchidos
      setOperacao('COMPRA');
      setMostrarFormulario(true);
      setFormData({
        id: row.ID,
        idCliente: row.ID_CLIENTE,
        data: row.DATA,
        exchange: row.EXCHANGE || 1,
        usdtPrecoUn: row.USDT_PRECO_UN || '',
        comissaoExchange: row.EXCHANGE_COMISSAO || '',
        compraBobDia: row.COMPRABOBDIA || '',
        nomeBRL: row.NOMEBRL || row.NOME_CLIENTE || '',
        valorBRL: row.VALORBRL || '',
        nomeBOB: row.NOMEBOB || '',
        valorBOB: row.VALORBOB || '',
        usdtQuantidade: row.USDT_QUANT || '',
      });
      return;
    }
    const id = row;
    setMostrarFormulario(true);
    setEditando(true);
    setFormData({
      id_cliente: id.IDCLIENTE || "",
      idCliente: id.IDCLIENTE || id.ID_CLIENTE || null,
      id: id.ID || "",
      data: id?.DATA || "",
      compraBobDia: id?.COMPRABOBDIA || "",
      nomeBRL: id?.NOMEBRL || "",
      nomeBOB: id?.NOMEBOB || "",
      valorBRL: id?.VALORBRL || "",
      valorBOB: id?.VALORBOB || "",
      lucroBOB: "",
      lucroBRL: "",
      percBRL: "",
      taxaDia: "",
    });
  };

  const onChangeCompraForm = (field, value) => {
    setCompraForm((p) => {
      const next = { ...p, [field]: value };
      if (field === 'VALORBRL' || field === 'VALORBOB') {
        const toNum = (v) => {
          const n = parseFloat(String(v).replace(',', '.'));
          return Number.isFinite(n) ? n : 0;
        };
        const nBRL = toNum(next.VALORBRL);
        const nBOB = toNum(next.VALORBOB);
        next.COMPRABOBDIA = (nBRL > 0 && nBOB > 0) ? (nBOB / nBRL).toFixed(2) : next.COMPRABOBDIA;
      }
      return next;
    });
  };

  const updateCompraSubmit = async (e) => {
    e?.preventDefault?.();
    if (!compraForm) return;
    try {
      setIsLoading(true);
      const payload = {
        idCliente: compraForm.ID_CLIENTE,
        data: compraForm.DATA,
        exchange: compraForm.EXCHANGE,
        usdtPrecoUn: compraForm.USDT_PRECO_UN,
        comissaoExchange: compraForm.EXCHANGE_COMISSAO,
        nomeBRL: compraForm.NOMEBRL,
        valorBRL: compraForm.VALORBRL,
        nomeBOB: compraForm.NOMEBOB,
        valorBOB: compraForm.VALORBOB,
        compraBobDia: compraForm.COMPRABOBDIA,
      };
      const resp = await api.put(`/compras/${compraForm.ID}`, payload);
      if (resp.status === 200) toast.success('Compra atualizada!'); else toast.warn('Não foi possível atualizar.');
      // fecha formulário de edição se estiver usando modal custom (não mais necessário)
      await carregarLista('COMPRA');
    } catch (err) {
      toast.error('Erro ao atualizar compra.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async (id) => {

    //console.log("ln 341, função deletar", id);

    try {
      
      //const vendaParaDeletar = dataList.find(venda => venda.ID === id);

      //console.log("ln 134 vendaParaDeletar", vendaParaDeletar);

      const operLabel = tabelaOperacao === 'COMPRA' ? 'Compra' : 'Venda';
      const confirmacao = await confirm(`Tem certeza que deseja deletar essa ${operLabel}? Data: ${new Date(`${id.DATA}T00:00:00`).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' })}, Cliente: ${id.NOMEBRL || id.NOME_CLIENTE || ''}, ${id.VALORBRL} Reais, ${id.VALORBOB} Bols`);

      if (!confirmacao) {
        toast.warn("Exclusão cancelada pelo usuário.");
        return; // Sai da função se o usuário cancelar
      }
      setIsLoading(true);
      if (tabelaOperacao === 'COMPRA') {
        await api.delete(`/compras/${id.ID}`);
        await carregarLista('COMPRA');
        toast.success('Compra deletada com sucesso!');
      } else {
        await api.delete(`/vendas/${id.ID}`);
        await carregarLista('VENDA');
        toast.success('Venda deletada com sucesso!');
      }
    } catch (erro) {
      const status = erro?.response?.status;
      if (status === 500) {
        toast.error("Só um momento que estamos Deletando essa venda!");
        console.error("Erro 500 ao deletar venda:", erro);
      } else {
      toast.error(`Erro ao deletar ${tabelaOperacao === 'COMPRA' ? 'compra' : 'venda'}`);
      console.error("Erro ao deletar:", erro);
      }
    }
    setIsLoading(false);
    //setErroAoSalvarVenda(true);
  };

  const toggleFormulario = () => {
    // Se estiver fechando, apenas fecha e limpa flag de edição
    if (mostrarFormulario) {
      setEditando(false);
      setMostrarFormulario(false);
      return;
    }
    // Abrindo para novo lançamento: limpar campos exceto data e taxa
    const keepData = formData?.data || '';
    const keepTaxa = formData?.compraBobDia || '';
    setEditando(false);
    setFormData({
      data: keepData,
      compraBobDia: keepTaxa,
      nomeBRL: '',
      idCliente: null,
      valorBRL: '',
      nomeBOB: '',
      valorBOB: '',
      exchange: 1,
      usdtPrecoUn: '',
      comissaoExchange: '',
      usdtQuantidade: '',
    });
    setMostrarFormulario(true);
  };

  const filtroDataNomeCpf = (e) => {
    e.preventDefault();
    setFiltrosDoVendas(filtroVendas);
  };

  // Função pública para Tabela limpar filtros (limpa apenas o nome e aplica intervalo do mês atual)
  const limparFiltros = () => {
    const { start, end } = getMonthRange();
    setFiltroVendas((prev) => ({ ...prev, nomeFiltro: '', dataInicio: prev.dataInicio || start, dataFim: prev.dataFim || end }));
    setFiltrosDoVendas((prev) => ({ ...prev, nomeFiltro: '', dataInicio: prev?.dataInicio || start, dataFim: prev?.dataFim || end }));
    // Foca no campo de busca de nome
    if (nomeInputRef.current) nomeInputRef.current.focus();
  };

  //console.log("ln 393, mostar formulario: ", mostrarFormulario);


  const [showImportModal, setShowImportModal] = useState(false);
  const [importTarget, setImportTarget] = useState('COMPRA');
  const [importCsvPath, setImportCsvPath] = useState('');
  const [importArquivo, setImportArquivo] = useState(null);
  const [pendenciasImportacao, setPendenciasImportacao] = useState([]);
  const [taxasPendentes, setTaxasPendentes] = useState({});
  const [mostrarPendencias, setMostrarPendencias] = useState(false);
  const [dadosPendentesUpload, setDadosPendentesUpload] = useState({ arquivo: null, caminho: '', target: 'COMPRA' });
  const [taxasPreCalculadas, setTaxasPreCalculadas] = useState(null);
  const taxasAutoAplicadasRef = useRef(false);
  const abrirImportacao = (target = tabelaOperacao) => {
    setImportTarget(target || 'COMPRA');
    setShowImportModal(true);
  };

  const fecharImportacao = () => {
    setImportCsvPath('');
    setImportArquivo(null);
    setImportTarget('COMPRA');
    setShowImportModal(false);
  };

  const confirmarImportacao = async (e) => {
    e?.preventDefault?.();

    if (!importArquivo && !importCsvPath) {
      toast.warn('Selecione um arquivo CSV ou informe o caminho.');
      return;
    }

    try {
      setIsLoading(true);
      const formData = new FormData();
      if (importArquivo) formData.append('arquivo', importArquivo);
      if (importCsvPath) formData.append('csvPath', importCsvPath);

      if (importTarget === 'VENDA') {
        const resp = await api.post('/vendas/importar-csv', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        const imported = resp?.data?.imported || 0;
        console.log('Importação de vendas - salvos:', resp?.data?.salvos || []);
        console.log('Importação de vendas - não salvos:', resp?.data?.nao_salvos || []);
        if (resp.status === 201 && imported) {
          toast.success(`Importação de vendas concluída: ${imported} lançamento(s).`);
        } else {
          toast.info('Importação concluída. Nenhuma venda nova encontrada.');
        }
        if (resp?.data?.erros?.length) {
          toast.warn(`Algumas linhas foram ignoradas (${resp.data.erros.length}). Veja os detalhes no console.`);
          console.warn('Importação de vendas - detalhes:', resp.data);
        }
        await carregarLista('VENDA');
        fecharImportacao();
        return;
      }

      const resp = await api.post('/compras/importar-binance', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (resp.status === 201) {
        toast.success(`Importação concluída: ${resp.data?.imported || 0} registro(s).`);
        const duplicadas = Array.isArray(resp.data?.nao_salvos) ? resp.data.nao_salvos : [];
        const salvos = Array.isArray(resp.data?.salvos) ? resp.data.salvos : [];
        if (salvos.length) console.log('[importar compras] registros salvos', salvos);
        if (duplicadas.length) {
          toast.info(`${duplicadas.length} ordem(ns) ignorada(s) por já existirem.`);
          console.log('[importar compras] ordens ignoradas', duplicadas);
        }
        await carregarLista('COMPRA');
        fecharImportacao();
      } else if (resp.status === 200) {
        toast.info('Arquivo processado, nenhuma compra nova encontrada.');
        const duplicadas = Array.isArray(resp.data?.nao_salvos) ? resp.data.nao_salvos : [];
        const salvos = Array.isArray(resp.data?.salvos) ? resp.data.salvos : [];
        if (salvos.length) console.log('[importar compras] registros salvos', salvos);
        if (duplicadas.length) {
          toast.info(`${duplicadas.length} ordem(ns) ignorada(s) por já existirem.`);
          console.log('[importar compras] ordens ignoradas', duplicadas);
        }
        fecharImportacao();
      } else {
        const pend = resp.data?.pendencias || [];
        if (pend.length) {
          toast.warn('Existem datas sem taxa cadastrada. Informe as taxas para concluir.');
          setPendenciasImportacao(pend);
          setTaxasPendentes({});
          setMostrarPendencias(true);
          setDadosPendentesUpload({ arquivo: importArquivo, caminho: importCsvPath, target: 'COMPRA' });
          setShowImportModal(false);
        }
      }
    } catch (error) {
      const status = error?.response?.status;
      const pend = error?.response?.data?.pendencias || [];
      if (importTarget === 'COMPRA' && pend.length && status === 409) {
        toast.warn('Existem datas sem taxa cadastrada. Informe as taxas para concluir.');
        setPendenciasImportacao(pend);
        setTaxasPendentes({});
        setMostrarPendencias(true);
        setDadosPendentesUpload({ arquivo: importArquivo, caminho: importCsvPath, target: 'COMPRA' });
        setShowImportModal(false);
      } else {
        const mensagem = error?.response?.data?.error || 'Erro ao importar CSV.';
        toast.error(mensagem);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const fecharPendencias = () => {
    setMostrarPendencias(false);
    setPendenciasImportacao([]);
    setTaxasPendentes({});
    setDadosPendentesUpload({ arquivo: null, caminho: '', target: 'COMPRA' });
    taxasAutoAplicadasRef.current = false;
  };

  const atualizarTaxaPendencia = (data, valor) => {
    setTaxasPendentes((prev) => ({ ...prev, [data]: valor }));
  };

  useEffect(() => {
    if (!mostrarPendencias) return;
    if (taxasPreCalculadas !== null) return;

    const carregarTaxasPreCalculadas = async () => {
      try {
        const basePath = (import.meta.env.BASE_URL || '/').replace(/\/+$/, '/');
        const url = `${basePath}taxas_usd_bob_2024.json`;
        const resp = await fetch(url, { cache: 'no-store' });
        if (!resp.ok) throw new Error(`Falha ao carregar taxas pré-calculadas (${resp.status})`);
        const json = await resp.json();
        setTaxasPreCalculadas(json);
      } catch (error) {
        console.warn('Não foi possível carregar taxas pré-calculadas.', error);
      }
    };

    carregarTaxasPreCalculadas();
  }, [mostrarPendencias, taxasPreCalculadas]);

  useEffect(() => {
    if (!mostrarPendencias) {
      taxasAutoAplicadasRef.current = false;
      return;
    }
    if (!Array.isArray(pendenciasImportacao) || !pendenciasImportacao.length) return;
    if (!taxasPreCalculadas) return;

    let houveAtualizacao = false;
    setTaxasPendentes((prev) => {
      const atualizado = { ...prev };
      pendenciasImportacao.forEach(({ data }) => {
        if (!data) return;
        const jaTem = atualizado[data];
        if (jaTem) return;
        const valorTaxa = taxasPreCalculadas[data];
        if (valorTaxa === undefined || valorTaxa === null) return;
        atualizado[data] = String(valorTaxa);
        houveAtualizacao = true;
      });
      return houveAtualizacao ? atualizado : prev;
    });

    if (houveAtualizacao && !taxasAutoAplicadasRef.current) {
      toast.info('Taxas preenchidas automaticamente a partir do arquivo padrão.');
      taxasAutoAplicadasRef.current = true;
    }
  }, [mostrarPendencias, pendenciasImportacao, taxasPreCalculadas]);

  const confirmarPendencias = async (e) => {
    e?.preventDefault?.();
    if ((dadosPendentesUpload.target || 'COMPRA') !== 'COMPRA') {
      toast.error('Pendências de taxa são tratadas apenas para compras.');
      return;
    }
    const datasObrigatorias = Array.from(new Set(pendenciasImportacao.map((item) => item.data))).filter(Boolean);
    const faltando = datasObrigatorias.filter((data) => {
      const valor = taxasPendentes[data];
      const numero = parseFloat(valor);
      return !(Number.isFinite(numero) && numero > 0);
    });
    if (faltando.length) {
      toast.warn('Informe a taxa para todas as datas pendentes.');
      return;
    }

    if (!dadosPendentesUpload.arquivo && !dadosPendentesUpload.caminho) {
      toast.error('Não foi possível reenviar o arquivo da importação. Selecione novamente.');
      setMostrarPendencias(false);
      setShowImportModal(true);
      return;
    }

    try {
      setIsLoading(true);
      const formData = new FormData();
      if (dadosPendentesUpload.arquivo) formData.append('arquivo', dadosPendentesUpload.arquivo);
      if (dadosPendentesUpload.caminho) formData.append('csvPath', dadosPendentesUpload.caminho);
      formData.append('taxasManuais', JSON.stringify(taxasPendentes));
      console.log('[confirmarPendencias] Enviando taxas manuais', {
        datas: Object.keys(taxasPendentes),
        preview: taxasPendentes,
        possuiArquivo: Boolean(dadosPendentesUpload.arquivo),
        caminhoInformado: dadosPendentesUpload.caminho,
      });
      const resp = await api.post('/compras/importar-binance', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      console.log('[confirmarPendencias] Resposta backend', resp?.status, resp?.data);
      if (resp.status === 201) {
        toast.success(`Importação concluída: ${resp.data?.imported || 0} registro(s).`);
        const duplicadas = Array.isArray(resp.data?.nao_salvos) ? resp.data.nao_salvos : [];
        const salvos = Array.isArray(resp.data?.salvos) ? resp.data.salvos : [];
        if (salvos.length) console.log('[confirmarPendencias] registros salvos', salvos);
        if (duplicadas.length) {
          toast.info(`${duplicadas.length} ordem(ns) ignorada(s) por já existirem.`);
          console.log('[confirmarPendencias] ordens ignoradas', duplicadas);
        }
        await carregarLista('COMPRA');
        fecharPendencias();
        fecharImportacao();
      } else if (resp.status === 200) {
        toast.info('Arquivo processado, nenhuma compra nova encontrada.');
        const duplicadas = Array.isArray(resp.data?.nao_salvos) ? resp.data.nao_salvos : [];
        const salvos = Array.isArray(resp.data?.salvos) ? resp.data.salvos : [];
        if (salvos.length) console.log('[confirmarPendencias] registros salvos', salvos);
        if (duplicadas.length) {
          toast.info(`${duplicadas.length} ordem(ns) ignorada(s) por já existirem.`);
          console.log('[confirmarPendencias] ordens ignoradas', duplicadas);
        }
        fecharPendencias();
        fecharImportacao();
      } else {
        const pend = resp.data?.pendencias || [];
        if (pend.length) {
          toast.warn('Ainda existem datas sem taxa válida. Verifique os valores informados.');
          setPendenciasImportacao(pend);
        }
      }
    } catch (error) {
      console.error('[confirmarPendencias] Erro ao reenviar pendências', {
        status: error?.response?.status,
        data: error?.response?.data,
        message: error?.message,
      });
      const pend = error?.response?.data?.pendencias || [];
      if (pend.length) {
        toast.warn('Ainda existem datas sem taxa cadastrada.');
        setPendenciasImportacao(pend);
      } else {
        const mensagem = error?.response?.data?.error || 'Erro ao importar CSV.';
        toast.error(mensagem);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const datasPendentes = Array.from(new Set((pendenciasImportacao || []).map((item) => item.data))).filter(Boolean);
  const pendenciasAgrupadas = datasPendentes.map((data) => ({
    data,
    itens: pendenciasImportacao.filter((item) => item.data === data),
  }));

  return (
    
    <main className={styles.root}>
      <ConfirmModal />
     
      <h1 className={cx(ui.titg)}>Lançamentos do Dia</h1>
      {/*<div style={{ display: 'flex', gap: 12, alignItems: 'center', marginBottom: 8 }}>
        <label style={{ fontSize: 13 }}>Operação:</label>
        <select value={tabelaOperacao} onChange={(e)=> setTabelaOperacao(e.target.value)}>
          <option value="VENDA">VENDA</option>
          <option value="COMPRA">COMPRA</option>
        </select>
      </div>*/}
      <div className={`${styles['venda-form-container']} ${mostrarFormulario ? styles.active : ''} ${ui.divnegratelatotal}`}>
        {/*<button onClick={toggleFormulario} className="venda-fechar fechar-mais-767">
          <CgCloseO size={24} />
        </button>*/}
        {operacao === 'VENDA' ? (
          <Formulario
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            sugestoes={sugestoes}
            setSugestoes={setSugestoes}
            toggleFormulario={toggleFormulario}
            onNewSubmission={handleNewSubmission}
            formData={formData}
            setFormData={setFormData}
            onSwitchOperacao={() => setOperacao('COMPRA')}
            onImportarVendas={() => abrirImportacao('VENDA')}
          />
        ) : (
          <FormularioCompra
            onNewSubmission={handleNewSubmission}
            toggleFormulario={toggleFormulario}
            formData={formData}
            onSwitchOperacao={() => setOperacao('VENDA')}
            onImportarBinance={() => abrirImportacao('COMPRA')}
          />
        )}
      </div>
      <div className={styles['filtrosWrapper']}>
        <form className={styles['filtrosDataNomeCpf']} onSubmit={filtroDataNomeCpf}>
        <div className={`${styles['venda-filha']} ${styles['filtroNome'] || ''}`}>
        <label className={cx(ui.labdesktop)}>Nome</label>
        <input
          className={cx(ui.inpdesktop)}
          type="text"
          name='nomeFiltro'
          ref={nomeInputRef}
          value={filtroVendas.nomeFiltro}
          onChange={(e) => setFiltroVendas({ ...filtroVendas, nomeFiltro: e.target.value || "" })}
        />
        </div>
        
        <div className={`${styles['venda-filha']} ${styles['fitroOperacao'] || ''}`}>
          <label className={cx(ui.labdesktop)}>Operação:</label>
          <select className={cx(ui.seldesktop)} value={tabelaOperacao} onChange={(e)=> setTabelaOperacao(e.target.value)}>
            <option value="VENDA">VENDA</option>
            <option value="COMPRA">COMPRA</option>
          </select>
        </div>

        <div className={`${styles['venda-filha']} ${styles['filtroDataIni'] || ''}`}>
          <label className={cx(ui.labdesktop)}>Data inicio</label>
          <label className={cx(ui.labmobile)}>Inicio</label>
          <input
            className={cx(ui.inpdesktop)}
            name='dataInicio'
            type="date"
            value={filtroVendas.dataInicio}
            onChange={(e) => setFiltroVendas({ ...filtroVendas, dataInicio: e.target.value || "" })}
          />
        </div>

        <div className={`${styles['venda-filha']} ${styles['filtroDataFim'] || ''}`}>
          <label className={cx(ui.labdesktop)}>Data fim</label>
          <label className={cx(ui.labmobile)}>Fim</label>
          <input
            className={cx(ui.inpdesktop)}
            type="date"
            name='dataFim'
            value={filtroVendas.dataFim}
            onChange={(e) => setFiltroVendas({ ...filtroVendas, dataFim: e.target.value || "" })}
          />
        </div>
        
        <div className={`${styles['venda-filha']} ${styles['vendaFiltroBotao']}`}>
        <label className={`${ui.labdesktop} ${ui.labtransparente}`}>...</label>
        <button type="submit" className={`${ui.butdesktop} ${ui.btnPrimary}`} aria-label="Filtrar">
          <p className={styles['venda-search-text']}>Filtrar</p>
          <LuSearch className={styles['venda-search-svg']} />
        </button>
      </div>
        </form>
      </div>

    {showImportModal && (
      <div className={styles['import-modal-overlay']}>
        <div className={styles['import-modal']}>
          <h4>{importTarget === 'VENDA' ? 'Importar vendas (CSV)' : 'Importar compras da Binance'}</h4>
          <form onSubmit={confirmarImportacao}>
            <label className={cx(ui.labdesktop)}>
              Selecionar arquivo CSV
              <input
                className={cx(ui.inpdesktop)}
                type="file"
                accept=".csv"
                onChange={(e) => setImportArquivo(e.target.files?.[0] || null)}
              />
              {importArquivo && <span className={styles['import-file-name']}>{importArquivo.name}</span>}
            </label>
            <label>
              Caminho do CSV (opcional)
              <input
                className={cx(ui.inpdesktop)}
                type="text"
                placeholder={importTarget === 'VENDA'
                  ? 'frontend/Binance/cambios_jan2025_vendas_full.csv'
                  : 'frontend/Binance/part-...csv'}
                value={importCsvPath}
                onChange={(e) => setImportCsvPath(e.target.value)}
              />
            </label>
            <div className={styles['import-modal-actions']}>
              <button type="button" onClick={fecharImportacao} className={`${ui.butdesktop} ${ui.btnSecondary} ${styles['btn-cancelar-import']}`}>
                Cancelar
              </button>
              <button type="submit" className={`${ui.butdesktop} ${ui.btnPrimary} ${styles['btn-confirmar-import']}`}>
                Importar
              </button>
            </div>
          </form>
        </div>
      </div>
    )}

    {mostrarPendencias && (
      <div className={styles['import-modal-overlay']}>
        <div className={styles['import-modal']}>
          <h4>Informar taxas USD→BOB pendentes</h4>
          <form onSubmit={confirmarPendencias}>
            {pendenciasAgrupadas.map(({ data, itens }) => (
              <div key={data} className={styles['pendencia-grupo']}>
                <label>
                  Data {data}
                  <input
                    type="text"
                    inputMode="decimal"
                    value={taxasPendentes[data] ?? ''}
                    onChange={(e) => atualizarTaxaPendencia(data, e.target.value)}
                    placeholder="Informe a taxa USD→BOB"
                  />
                </label>
                <div className={styles['pendencia-detalhes']}>
                  {itens.map((item, idx) => (
                    <div key={`${data}-${idx}`} className={styles['pendencia-item']}>
                      <span>Ordem: {item.orderNumber || 'N/A'}</span>
                      <span>Quantidade (USDT): {item.quantity}</span>
                      <span>Total BRL: {item.totalPrice}</span>
                      <span>Parceiro: {item.counterparty || 'N/A'}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
            <div className={styles['import-modal-actions']}>
              <button type="button" onClick={fecharPendencias} className={`${ui.btn} ${ui.btnSecondary} ${styles['btn-cancelar-import']}`}>
                Cancelar
              </button>
              <button type="submit" className={`${ui.btn} ${ui.btnPrimary} ${styles['btn-confirmar-import']}`}>
                Confirmar taxas
              </button>
            </div>
          </form>
        </div>
      </div>
    )}

      {/* edição de compras usa o formulário principal com formData preenchido */}
      <div className={styles['venda-tabela-cont']}>
        <Tabela
          setErroAoSalvarVenda={setErroAoSalvarVenda}
          erroAoSalvarVenda={erroAoSalvarVenda}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          setDataListTabela={setDataListTabela}
          dataListTabela={dataListTabela}
          enviarConfPai={(items) => {
            // Reencaminha para endpoint correto conforme filtro atual
            if (tabelaOperacao === 'COMPRA') {
              const itensASalvar = Object.values(items);
              if (!itensASalvar.length) return;
              setIsLoading(true);
              Promise.all(itensASalvar.map((it) =>
                api.put(`/compras/conferencia/${it.ID}`, {
                  CONFVALORBRL: it.CONFVALORBRL, // Tabela usa ambos; backend de compras só aceita CONFVALORBOB
                  CONFVALORBOB: it.CONFVALORBOB,
                }).then((res)=>({ok:true,id:it.ID,res})).catch((err)=>({ok:false,id:it.ID,err}))
              ))
              .then(async (resultados) => {
                const sucesso = resultados.filter(r=>r.ok).length; const falhas = resultados.length - sucesso;
                if (sucesso) toast.success(`Conferência (compras) salva para ${sucesso} item(ns).`);
                if (falhas) toast.error(`${falhas} falha(s) ao salvar conferência.`);
                await carregarLista(tabelaOperacao);
              })
              .finally(()=> setIsLoading(false));
            } else {
              enviarConf(items);
            }
          }}
          formData={formData}
          dataList={dataList}
          setDataList={setDataList}
          onEdit={handleEdit}
          onDelete={handleDelete}
          filtrosDoVendas={filtrosDoVendas}
          setFiltrosDoVendas={setFiltrosDoVendas}
          limparFiltros={limparFiltros}
          toggleFormulario={toggleFormulario}
          tabelaOperacao={tabelaOperacao}
        />
      </div>
      
      <ToastContainer limit={1} position="top-right" autoClose={3000} />
      <Spinner 
        isLoading={isLoading}
        //setIsLoading={setIsLoading}
      />
    </main>
  );
}

export default Vendas;
